import {
    MonitoredEventForm,
    MonitoredEventFormProps,
    MonitoredEventFormState,
    MonitoredEventFormValues,
} from 'app/components/panels/predict/MonitoredEventForm';
import { OPS_INSTRUCTION_CLAZZ_VALUE, OpsInstruction } from 'app/model/SOL49';
import { Button, Col, Form, Input, Row } from 'antd';
import ConditionalRender from 'app/common/components/ConditionalRender';
import Utils from 'app/common/util/Utils';
import TimeUtils from 'app/common/util/TimeUtils';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';
import React from 'react';

type OpsInstructionsFormValues = MonitoredEventFormValues<OpsInstruction>;

interface OpsInstructionsFormProps extends MonitoredEventFormProps<OpsInstruction> {}

interface OpsInstructionsFormState extends MonitoredEventFormState {
    numPages: number;
    pageNumber: number;
}

export class OpsInstructionsForm extends MonitoredEventForm<
    OpsInstruction,
    OpsInstructionsFormValues,
    OpsInstructionsFormProps,
    OpsInstructionsFormState
> {
    constructor(props) {
        super(props);

        this.state = { ...this.state, numPages: 0, pageNumber: 0 };
    }

    render() {
        return (
            <Form
                ref={this.formRef}
                style={{ width: OpsInstructionsForm.FORM_WIDTH_EM }}
                layout="vertical"
                onValuesChange={() =>
                    this.setState({
                        updateDisabled: this.isUpdateDisabled(),
                        createDisabled: this.isCreateDisabled(),
                    })
                }>
                <Form.Item name="clazz" hidden>
                    <Input type="hidden" />
                </Form.Item>
                <Form.Item name="ack" hidden>
                    <Input type="hidden" />
                </Form.Item>
                <Form.Item name="pdf" hidden>
                    <Input type="hidden" />
                </Form.Item>
                <Form.Item name="id" hidden>
                    <Input type="hidden" />
                </Form.Item>
                {MonitoredEventForm.FORM_TITLE_ITEM}
                {MonitoredEventForm.FORM_VALIDITY_ITEM}
                {MonitoredEventForm.FORM_DESCRIPTION_ITEM(5)}
                <Row gutter={8}>
                    <Col span={20}>
                        <ConditionalRender condition={Utils.isExists(this.props.event?.lastUpdate)}>
                            <span>Last update: {TimeUtils.formatDateHHMM(this.props.event?.lastUpdate)}</span>
                        </ConditionalRender>
                    </Col>
                    <Col span={4}>
                        <Button onClick={this.onSubmit} disabled={this.state.updateDisabled}>
                            Update
                        </Button>
                    </Col>
                </Row>
            </Form>
        );
    }

    protected toFormValues(event: OpsInstruction): OpsInstructionsFormValues {
        return {
            ...event,
            clazz: OPS_INSTRUCTION_CLAZZ_VALUE,
            validity: TimePeriodUtils.timePeriodToMoment(event?.validity),
        };
    }

    protected fromFormValues(values: OpsInstructionsFormValues) {
        return {
            ...values,
            validity: TimePeriodUtils.momentToTimePeriod(values.validity),
        };
    }

    protected isUpdateDisabled = () => {
        if (!this.formRef.current?.getFieldsValue() || !this.props.event) return true;
        const values: OpsInstructionsFormValues = this.formRef.current.getFieldsValue();
        const event = this.props.event;

        return super.isUpdateDisabled() && values.description === event.description;
    };
}
